import * as types from './constants';

export const setClientArea = data => ({
  type: types.SET_CLIENT_AREA,
  data
});

export const setClientAreaPlans = data => ({
  type: types.SET_CLIENT_AREA_PLANS,
  data
});

export const clearClientArea = () => ({
  type: types.CLEAR_CLIENT_AREA
});

export const handleLoading = status => ({
  type: types.HANDLE_LOADING,
  status
});

export const handlePlansLoading = status => ({
  type: types.HANDLE_PLANS_LOADING,
  status
});

export const handleSendEmailLoading = status => ({
  type: types.HANDLE_SEND_EMAIL_LOADING,
  status
});